export default function AdminCustomerLineLabel({ displayName, username }) {
    const resolvedName = displayName?.trim() || username || "—";
    const showUsername = username && username !== resolvedName;

    return (
        <dl className="profile-detail-view admin-line-customer">
            <div className="profile-detail-row">
                <dt>Client</dt>
                <dd>
                    <strong>{resolvedName}</strong>
                    {showUsername && <span className="muted admin-line-customer-username"> ({username})</span>}
                </dd>
            </div>
        </dl>
    );
}
